(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6620],{

/***/ 30228:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/brochure",
      function () {
        return __webpack_require__(8007);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 8007:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28598);
/* harmony import */ var _components_form_fields__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68143);
/* harmony import */ var _components_form_layout__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(76817);
/* harmony import */ var _components_ui__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20388);
/* harmony import */ var _contexts_index__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(28798);
/* harmony import */ var _hookform_resolvers_yup__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(97859);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67958);
/* harmony import */ var _utils_helpers__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(45911);
/* harmony import */ var _utils_helpers_tracking__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(68379);
/* harmony import */ var _utils_schemas__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(73705);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(46392);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(82684);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(75367);
/* eslint-disable @next/next/no-img-element */ 












const Brochure = (param)=>{
    let { models , content , tracking , settings , brand , dealer , model , query  } = param;
    const campaign = (0,_contexts_index__WEBPACK_IMPORTED_MODULE_4__/* .useCampaign */ .yQ)();
    const [formStep, setFormStep] = (0,react__WEBPACK_IMPORTED_MODULE_10__.useState)(1);
    const [user, setUser] = (0,react__WEBPACK_IMPORTED_MODULE_10__.useState)(false);
    const [isVehicleExpanded, expandVehicle] = (0,react__WEBPACK_IMPORTED_MODULE_10__.useState)(false);
    const [isDetailsExpanded, expandDetails] = (0,react__WEBPACK_IMPORTED_MODULE_10__.useState)(false);
    const [formData, setFormData] = (0,react__WEBPACK_IMPORTED_MODULE_10__.useState)({});
    const [submitResponse, setSubmitResponse] = (0,react__WEBPACK_IMPORTED_MODULE_10__.useState)("");
    const step = (newFormStep, userState)=>{
        setUser(userState);
        setFormStep(newFormStep);
    };
    const initialValues = {
        title: "",
        first_name: "",
        last_name: "",
        email: "",
        model: "",
        consent: {
            user: false
        },
        campaign_response_code: "",
        campaign_code: "",
        response_code: "",
        dealer: "",
        dealername: "",
        is_lexus: brand === "lexus"
    };
    const methods = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_11__/* .useForm */ .cI)({
        resolver: (0,_hookform_resolvers_yup__WEBPACK_IMPORTED_MODULE_12__/* .yupResolver */ .X)(_utils_schemas__WEBPACK_IMPORTED_MODULE_8__/* .BrochureSchema */ .t1),
        defaultValues: initialValues,
        mode: "onTouched"
    });
    const VehicleStep = ()=>formData.modelName ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "relative ".concat(brand === "lexus" ? " uppercase" : ""),
            "data-gt-name": "componentevent",
            "data-gt-componentname": "brochure-request",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "md:flex items-center",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                        className: "flex hover:underline",
                        onClick: ()=>{
                            step(1, true);
                            expandDetails(false);
                            expandVehicle(false);
                            setFormData((state)=>{
                                return {
                                    ...state,
                                    modelImage: "",
                                    modelName: "",
                                    fuel: null
                                };
                            });
                            setSubmitResponse("");
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex flex-col items-baseline md:flex-row md:space-x-2 md:justify-between",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "font-medium ".concat(brand === "lexus" ? " uppercase" : ""),
                                    children: [
                                        "1. ",
                                        brand === "lexus" ? "Car" : "Vehicle"
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "text-tiny",
                                    children: "Change"
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                    className: "md:flex text-tiny hidden mt-1",
                    "data-gt-action": "nav-".concat(isVehicleExpanded ? "open" : "close", "-dropdown"),
                    "data-gt-label": "vehicle",
                    onClick: ()=>{
                        expandVehicle((state)=>!state);
                        expandDetails(false);
                    },
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            children: formData.modelName
                        }),
                        formData.label && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "ml-1",
                            children: [
                                " ",
                                formData.label
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "ml-1 mt-1",
                            children: isVehicleExpanded ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                fill: "none",
                                viewBox: "0 0 24 24",
                                strokeWidth: 3,
                                stroke: "currentColor",
                                className: "w-4 h-4",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round",
                                    d: "M4.5 15.75l7.5-7.5 7.5 7.5"
                                })
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                fill: "none",
                                viewBox: "0 0 24 24",
                                strokeWidth: 3,
                                stroke: "currentColor",
                                className: "w-4 h-4",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round",
                                    d: "M19.5 8.25l-7.5 7.5-7.5-7.5"
                                })
                            })
                        })
                    ]
                }),
                isVehicleExpanded && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "absolute top-[70px] p-[15px] shadow-md z-[10] w-[300px] bg-white",
                    "data-gt-componentgroup": "forms",
                    "data-gt-name": "componentevent",
                    "data-gt-componentname": "brochure-request",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex justify-between",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "text-lg font-medium",
                                            children: formData.modelName
                                        }),
                                        formData.fuel !== undefined && formData.fuel.toLowerCase() !== "petrol" && formData.fuel.toLowerCase() !== "diesel" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "".concat(brand === "toyota" ? "font-medium text-blue" : "", " uppercase"),
                                            children: formData.fuel
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                    onClick: ()=>{
                                        expandVehicle((state)=>!state);
                                        expandDetails(false);
                                    },
                                    "data-gt-action": "nav-close-dropdown",
                                    "data-gt-label": "vehicle",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                                        xmlns: "http://www.w3.org/2000/svg",
                                        fill: "none",
                                        viewBox: "0 0 24 24",
                                        strokeWidth: 1.5,
                                        stroke: "currentColor",
                                        className: "w-6 h-6",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                            strokeLinecap: "round",
                                            strokeLinejoin: "round",
                                            d: "M6 18L18 6M6 6l12 12"
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                            className: "w-[100%] font-medium mt-4",
                            src: formData.modelImage,
                            alt: formData.modelName
                        })
                    ]
                })
            ]
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "font-semibold",
            children: [
                "1. ",
                brand === "lexus" ? "Car" : "Vehicle"
            ]
        });
    const DetailsStep = ()=>formData.first_name ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "relative ".concat(brand === "lexus" ? " uppercase" : ""),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "md:flex items-center",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                        className: "flex md:ml-[10px] hover:underline",
                        onClick: ()=>{
                            step(4, true);
                            expandDealer(false);
                            expandDetails(false);
                            expandVehicle(false);
                            setFormData((state)=>{
                                return {
                                    ...state,
                                    first_name: "",
                                    last_name: "",
                                    email: "",
                                    phone: ""
                                };
                            });
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex flex-col items-baseline md:flex-row md:space-x-2 md:justify-between",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "font-medium ".concat(brand === "lexus" ? " uppercase" : ""),
                                    children: "2. Details"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "text-tiny",
                                    children: "Change"
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                    className: "md:flex text-[13px] mt-[10px] leading-[10px] invisible lg:visible",
                    onClick: ()=>{
                        expandDetails((state)=>!state);
                        expandDealer(false);
                        expandVehicle(false);
                    },
                    "data-gt-action": "".concat(isDetailsExpanded ? "open" : "close", "-dropdown"),
                    "data-gt-label": "details",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            children: [
                                "".concat(formData.first_name, " "),
                                " "
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "ml-1 mt-1",
                            children: isDetailsExpanded ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                fill: "none",
                                viewBox: "0 0 24 24",
                                strokeWidth: 3,
                                stroke: "currentColor",
                                className: "w-4 h-4",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round",
                                    d: "M4.5 15.75l7.5-7.5 7.5 7.5"
                                })
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                fill: "none",
                                viewBox: "0 0 24 24",
                                strokeWidth: 3,
                                stroke: "currentColor",
                                className: "w-4 h-4",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round",
                                    d: "M19.5 8.25l-7.5 7.5-7.5-7.5"
                                })
                            })
                        })
                    ]
                }),
                isDetailsExpanded && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "absolute top-[70px] p-[15px] shadow-md z-[10] w-[300px] bg-white",
                    "data-gt-componentgroup": "forms",
                    "data-gt-name": "componentevent",
                    "data-gt-componentname": "brochure-request",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex justify-between ",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "",
                                    children: "".concat(formData.first_name, " ").concat(formData.last_name)
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                    onClick: ()=>{
                                        expandDetails((state)=>!state);
                                        expandDealer(false);
                                        expandVehicle(false);
                                    },
                                    "data-gt-action": "nav-close-dropdown",
                                    "data-gt-label": "details",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                                        xmlns: "http://www.w3.org/2000/svg",
                                        fill: "none",
                                        viewBox: "0 0 24 24",
                                        strokeWidth: 1.5,
                                        stroke: "currentColor",
                                        className: "w-6 h-6",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                            strokeLinecap: "round",
                                            strokeLinejoin: "round",
                                            d: "M6 18L18 6M6 6l12 12"
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "",
                            children: [
                                " ",
                                "".concat(formData.email, " ")
                            ]
                        })
                    ]
                })
            ]
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "flex flex-row",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "".concat(formStep === 2 ? "font-semibold" : "font-medium"),
                children: "2. Details"
            })
        });
    (0,react__WEBPACK_IMPORTED_MODULE_10__.useEffect)(()=>{
        if (dealer) {
            var ref, ref1;
            methods.setValue("dealer", (dealer === null || dealer === void 0 ? void 0 : (ref = dealer.applications) === null || ref === void 0 ? void 0 : (ref1 = ref.NMSC) === null || ref1 === void 0 ? void 0 : ref1.externalID) ? dealer.applications.NMSC.externalID : "");
            methods.setValue("dealername", (dealer === null || dealer === void 0 ? void 0 : dealer.name) ? dealer.name : "");
        }
    }, [
        dealer
    ]);
    const onSubmit = async (data)=>{
        setSubmitResponse("");
        await (0,axios__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP)({
            method: "post",
            url: "".concat("https://api.toyota.co.uk/forms/api", "/brochure"),
            headers: {
                "Content-Type": "application/json"
            },
            data
        }).then(()=>{
            (0,_utils_helpers_tracking__WEBPACK_IMPORTED_MODULE_7__/* .formEvent */ .Be)({
                conversion: 1,
                name: tracking.form,
                step: "form-submit",
                variant: "",
                page: tracking.page
            });
            (0,_utils_helpers__WEBPACK_IMPORTED_MODULE_6__/* .closeOverlay */ .Km)(content.confirmation.title, content.confirmation.copy, setSubmitResponse);
        }).catch(()=>{
            (0,_utils_helpers_tracking__WEBPACK_IMPORTED_MODULE_7__/* .formEvent */ .Be)({
                conversion: 0,
                name: tracking.form,
                step: "form-error",
                variant: "",
                page: tracking.page
            });
            setSubmitResponse(_utils_constants__WEBPACK_IMPORTED_MODULE_5__/* .ERROR_MESSAGE */ .c9);
            throw new Error(_utils_constants__WEBPACK_IMPORTED_MODULE_5__/* .ERROR_MESSAGE */ .c9);
        });
    };
    (0,react__WEBPACK_IMPORTED_MODULE_10__.useEffect)(()=>{
        if (campaign === null || campaign === void 0 ? void 0 : campaign.campaign) {
            methods.setValue("campaign_code", campaign.campaign);
        }
        if (campaign === null || campaign === void 0 ? void 0 : campaign.media) {
            const code = methods.getValues("campaign_code");
            methods.setValue("campaign_code", code + campaign.media);
        }
        if (campaign === null || campaign === void 0 ? void 0 : campaign.brochure) {
            methods.setValue("campaign_response_code", campaign.brochure);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        campaign
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_10__.useEffect)(()=>{
        if (model) {
            methods.setValue("model", model.d4t4.id);
            setFormData((state)=>{
                var ref, ref1, ref2, ref3, ref4;
                return {
                    ...state,
                    modelImage: (0,_utils_helpers__WEBPACK_IMPORTED_MODULE_6__/* .getModelImage */ .gU)(brand, model === null || model === void 0 ? void 0 : (ref = model.image) === null || ref === void 0 ? void 0 : ref.id, model === null || model === void 0 ? void 0 : (ref1 = model.image) === null || ref1 === void 0 ? void 0 : ref1.grade, model === null || model === void 0 ? void 0 : (ref2 = model.image) === null || ref2 === void 0 ? void 0 : ref2.color, "webp", model === null || model === void 0 ? void 0 : (ref3 = model.image) === null || ref3 === void 0 ? void 0 : ref3.fallback),
                    modelName: model.name,
                    fuel: model === null || model === void 0 ? void 0 : (ref4 = model.filters) === null || ref4 === void 0 ? void 0 : ref4.fuel[0]
                };
            });
            if ((query === null || query === void 0 ? void 0 : query.method) === "email") {
                step(2, false);
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        model
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui__WEBPACK_IMPORTED_MODULE_3__/* .Nav */ .JL, {
                title: content.title,
                logoType: content === null || content === void 0 ? void 0 : content.logotype,
                customLogo: content === null || content === void 0 ? void 0 : content.customlogo,
                steps: [
                    VehicleStep(),
                    DetailsStep()
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_form_layout__WEBPACK_IMPORTED_MODULE_2__/* .FormWrapper */ .n, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_form_layout__WEBPACK_IMPORTED_MODULE_2__/* .FormStep */ .p, {
                        title: content.car.title,
                        step: formStep,
                        active: formStep === 1,
                        user: user,
                        tracking: {
                            conversion: 0,
                            name: tracking.form,
                            step: "select-model",
                            variant: tracking.variant,
                            page: tracking.page
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_form_fields__WEBPACK_IMPORTED_MODULE_1__/* .ModelGrid */ .fZ, {
                            type: "brochure",
                            models: models,
                            pricelist: settings === null || settings === void 0 ? void 0 : settings.pricelist_url,
                            showFilter: content.car.filter,
                            setModel: (selectedModel)=>{
                                var ref, ref1;
                                setTimeout(()=>{
                                    window.scrollTo({
                                        top: 0,
                                        left: 0,
                                        behavior: "smooth"
                                    });
                                }, 100);
                                methods.setValue("model", selectedModel.d4t4.id);
                                methods.setValue("response_code", dealer ? (selectedModel === null || selectedModel === void 0 ? void 0 : (ref = selectedModel.responsecodes) === null || ref === void 0 ? void 0 : ref.dealer_email) || "" : (selectedModel === null || selectedModel === void 0 ? void 0 : (ref1 = selectedModel.responsecodes) === null || ref1 === void 0 ? void 0 : ref1.national_email) || "");
                                setFormData((state)=>{
                                    var ref, ref1, ref2, ref3, ref4;
                                    return {
                                        ...state,
                                        modelImage: (0,_utils_helpers__WEBPACK_IMPORTED_MODULE_6__/* .getModelImage */ .gU)(brand, selectedModel === null || selectedModel === void 0 ? void 0 : (ref = selectedModel.image) === null || ref === void 0 ? void 0 : ref.id, selectedModel === null || selectedModel === void 0 ? void 0 : (ref1 = selectedModel.image) === null || ref1 === void 0 ? void 0 : ref1.grade, selectedModel === null || selectedModel === void 0 ? void 0 : (ref2 = selectedModel.image) === null || ref2 === void 0 ? void 0 : ref2.color, "webp", selectedModel === null || selectedModel === void 0 ? void 0 : (ref3 = selectedModel.image) === null || ref3 === void 0 ? void 0 : ref3.fallback),
                                        modelName: selectedModel.name,
                                        fuel: selectedModel === null || selectedModel === void 0 ? void 0 : (ref4 = selectedModel.filters) === null || ref4 === void 0 ? void 0 : ref4.fuel[0]
                                    };
                                });
                                step(2, true);
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_form_layout__WEBPACK_IMPORTED_MODULE_2__/* .FormStep */ .p, {
                        title: content.details.title,
                        step: formStep,
                        active: formStep === 2,
                        user: user,
                        tracking: {
                            conversion: 0,
                            name: tracking.form,
                            step: "contact-details",
                            variant: tracking.variant,
                            page: tracking.page
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_hook_form__WEBPACK_IMPORTED_MODULE_11__/* .FormProvider */ .RV, {
                            ...methods,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("form", {
                                onSubmit: methods.handleSubmit(onSubmit),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_form_fields__WEBPACK_IMPORTED_MODULE_1__/* .AuthFill */ .Pl, {}),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_form_fields__WEBPACK_IMPORTED_MODULE_1__/* .Title */ .Dx, {}),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_form_fields__WEBPACK_IMPORTED_MODULE_1__/* .FirstName */ .SW, {}),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_form_fields__WEBPACK_IMPORTED_MODULE_1__/* .LastName */ .uQ, {}),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_form_fields__WEBPACK_IMPORTED_MODULE_1__/* .Email */ .GT, {}),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_form_fields__WEBPACK_IMPORTED_MODULE_1__/* .MarketingConsent */ .nb, {}),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_form_fields__WEBPACK_IMPORTED_MODULE_1__/* .Button */ .zx, {
                                        submitResponse: submitResponse,
                                        children: content.details.submit
                                    })
                                ]
                            })
                        })
                    })
                ]
            })
        ]
    });
};
Brochure.whyDidYouRender = true;
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (Brochure);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7409,1850,9595,9516,388,4817,9774,2888,179], function() { return __webpack_exec__(30228); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);